import { render, staticRenderFns } from "./鉴证书详情.vue?vue&type=template&id=b5b69df2&scoped=true"
import script from "./鉴证书详情.vue?vue&type=script&lang=js"
export * from "./鉴证书详情.vue?vue&type=script&lang=js"
import style0 from "./鉴证书详情.vue?vue&type=style&index=0&id=b5b69df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5b69df2",
  null
  
)

export default component.exports